module.exports = __webpack_public_path__ + "img/a-symbol-gray.svg";